<template>
  <div>







 




  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>






  <div  >
 
<div   v-if='loadstatus' style="" class="heads"> 




<div class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper d-flex  ">
  <div class="container  ">

  <div class="headerui     ">
  
<div class="d-flex align-items-center mr-4  logowrapper">
  <div class="imgwrapui"> 
    <img :src="info.logo"  class="img-fluid" >
  </div>
  <div>
    <p class="businessname">{{info.name}}</p>
    <div class="d-flex align-items-center">
      <i class='bx bxs-badge-check verifiedicon' ></i>
      <p class="verified">Trusted Seller</p>

    </div>

  </div>
</div>

<div class="inputboxui    ">
  <i class='bx bx-search searchsize' ></i>
  <div class="actualinputbox">

    <input type="text" class="form-control searchinput" placeholder="Search for products..."  name="">
    
  </div>
  
</div>

<div class="d-flex align-items-center  navwrapper  ml-3   ">

  <div class="d-flex align-items-center navitem">
    

  
<svg style='width:20px' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" alt="Categories" color="" text=""><g fill="none" fill-rule="evenodd">
  <g fill="#4D4D4D" fill-rule="nonzero"><g><g><path d="M20.497 13c.829 0 1.5.672 1.5 1.5v6c0 .828-.671 1.5-1.5 1.5h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6zM9.5 13c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6zm10.797 1.7h-5.6v5.6h5.6v-5.6zM9.3 14.7H3.7v5.6h5.6v-5.6zM9.5 2c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-6C2.672 11 2 10.328 2 9.5v-6C2 2.672 2.672 2 3.5 2h6zm10.997 0c.829 0 1.5.672 1.5 1.5v6c0 .828-.671 1.5-1.5 1.5h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6zM9.3 3.7H3.7v5.6h5.6V3.7zm10.997 0h-5.6v5.6h5.6V3.7z" transform="translate(-282 -97) translate(282 91) translate(0 6)"></path></g></g></g></g>
</svg>
      <p class="navitemstext">Categories</p>


  </div>
  <router-link  :to="'/'+$route.params.shopname+'/bag'"style='text-decoration:none'>
  <div class="d-flex align-items-center navitem">
    

  
<svg style='width:20px' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 28 28" alt="Bag" color="" text=""><g fill="none" fill-rule="evenodd"><g fill="#4D4D4D" fill-rule="nonzero"><g><path d="M20.452 2.333c.287 0 .558.136.73.366L24.41 7l.01.014c.015.02.03.043.044.067l.022.04c.011.02.021.04.03.062l.014.032c.01.027.02.055.028.082l.006.026c.006.023.011.047.015.07.009.051.013.103.013.155v15.054c0 1.693-1.372 3.065-3.064 3.065H6.473c-1.692 0-3.064-1.372-3.064-3.065V7.548c0-.05.004-.099.012-.148.017-.104.051-.203.1-.293.021-.037.045-.073.07-.107l-.05.074c.013-.022.028-.043.043-.064L3.59 7l3.226-4.301c.173-.23.444-.366.731-.366zm2.31 6.13H5.237v14.14c0 .594.42 1.09.98 1.209l.122.02.135.007h15.054c.683 0 1.236-.554 1.236-1.237V8.462zm-4.46 2.472c.504 0 .913.41.913.914 0 2.88-2.335 5.216-5.215 5.216s-5.215-2.335-5.215-5.216c0-.504.41-.914.914-.914.505 0 .914.41.914.914 0 1.871 1.516 3.388 3.387 3.388 1.87 0 3.387-1.517 3.387-3.388 0-.504.41-.914.914-.914zm1.693-6.774H8.005L6.148 6.634h15.7l-1.854-2.473z" transform="translate(-1089 -74) translate(1089 74)"></path></g></g></g></svg>
      <p class="navitemstext">Bag</p>


  </div>
</router-link>
 







</div>

</div>

  </div>
  
</div>







 




<!--- header -->




 



 
 
<!--
 
 


 



<div    class="logbox d-flex justify-content-center mt-5" style="height:40vh">
  
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="box-shadow:none!important;border:1px solid #e6e6e6" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Enter mobile number</p>
               </div>


                            <div style="position: relative;" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="font-size:16px">+91</p>
                              
                              <div style="flex:1">
                                
                        
                            <input autofocus=""  type="number" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>
                          </div>
                              <div id="recaptcha-container"></div>

                   

 
                              <div class="d-flex align-items-center justify-content-center">

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#073642;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#073642;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:470px;position:relative;z-index:100000000">
        
 <div style="box-shadow:none!important;border:1px solid #e6e6e6" class="loginwrapper">
            
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">OTP Verification</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='closeloginbox'></i>
              </div>

                      
                  <p style="color:#808080;font-size:14px;text-align:center;font-weight:400;margin:30px 0;margin-bottom:30px">OTP sent successfully!</p>

            <div  class="otpboxes my-4">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
      @on-complete="subotp"
       
    />
  </div>
                           

                   
 
                              

       
          
        </div>
    
  </div>




</div>





 




-->

<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

 
                              <div class="d-flex align-items-center justify-content-center martp" style="" >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
      @on-complete="subotp"
       
    />
  </div>
                           

                   
 
                              

       
          
        </div>
    
  </div>




</div>










  



<!--footer -->

<div class="d-md-block d-none mt-4">
  <img src="https://firebasestorage.googleapis.com/v0/b/todoapp-f839f.appspot.com/o/custom%20upload%2FScreenshot%202021-07-24%20at%209.20.13%20PM.png?alt=media&token=0815845f-d049-4346-b8f7-5494216a8c33" style="width: 100%">
</div>

<div class="d-md-none d-block  mt-4">
  <img src="https://firebasestorage.googleapis.com/v0/b/todoapp-f839f.appspot.com/o/custom%20upload%2FScreenshot%202021-07-25%20at%204.57.43%20PM.png?alt=media&token=b1d9a7eb-17ff-4cbc-b3ee-29eb3fd249d4
" style="width: 100%">
</div>






 
 
  </div>
</div>
</div>
</template>

<script>
 
  import firebase from 'firebase'

  var coderesult
const fb = require('./firebaseconfig.js')
export default {

          props: ['loadstatus','info','carts'],


  
  data () {

        return{

         phone:'',
            otp:'',
            logintype:'send',
            phonetext:'Phone number',
            otptext:'OTP',
            errs:false,
            disp:'none',
            otpdes:true,
            perrs:false,
            user:false,
            loginbox:false,


 


        }
     
    
  },
   
      
  created(){

 
 
   if(firebase.auth().currentUser){


this.user=true
this.$router.replace({ path: '/'+this.$route.params.shopname })


 
 }else{

 this.user=false

 }

 


   },

 

   methods:{
   
 

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/'+this.$route.params.shopname+'/account' })

 }else{
this.loginbox=true
 }
    },
    

    closeloginbox(){
      this.loginbox=false
      this.logintype='send'
    }
   ,
subotp(value){

var vm=this;
 
 
  
     coderesult.confirm(value).then(function (result) {


      
        var user=result.user;
       
 vm.logintype='send'
 vm.loginbox=false
 
vm.$router.push({ path: '/'+vm.$route.params.shopname })

       vm.phone=''
       


 


    }).catch(function (error) {

        vm.perrs=true
      vm.otptext='Invalid Otp'
      console.log('errorr')
       console.log(error.message);
    
    });


},


      login(){

 
 
var vm=this


 
vm.appVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function(response) {
    

vm.logintype='otp'
 
        


              
            },
            'expired-callback': function() {
             
             vm.logintype='send'
             alert('---')
vm.loginbox=false

            }
    });

 
    fb.auth.signInWithPhoneNumber('+91'+vm.phone, vm.appVerifier).then(function (confirmationResult) {

        
        //s is in lowercase
        window.confirmationResult=confirmationResult;
        coderesult=confirmationResult;
     
        

    }).catch(function (error) {
        alert(error.message);
    });

},
    
    


 





 }

   
    
 
  
}
</script>
<style scoped >

 
 
</style>
 



// WEBPACK FOOTER //
// src/login.vue